function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Flow",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Confirmation",
  transform: "translate(-40.000000, -421.000000)",
  fill: "#391D4D",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "ic_star_border_24px",
  transform: "translate(40.000000, 421.000000)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M38,13.7178947 L24.339,12.5431579 L19,0 L13.661,12.5621053 L0,13.7178947 L10.374,22.68 L7.258,36 L19,28.9326316 L30.742,36 L27.645,22.68 L38,13.7178947 Z M19,25.3894737 L11.856,29.6905263 L13.756,21.5810526 L7.448,16.1242105 L15.77,15.4042105 L19,7.76842105 L22.249,15.4231579 L30.571,16.1431579 L24.263,21.6 L26.163,29.7094737 L19,25.3894737 Z",
  id: "Shape"
}))));

var SvgStars = function SvgStars(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "38px",
    height: "36px",
    viewBox: "0 0 38 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStars, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Stars.41fb914c.svg";
export { ForwardRef as ReactComponent };